import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import React from "react";
import { useWorkspaceStore } from "../../store/workspace/WorkspaceStore";
import { Workspace } from "../../types/workspace";

export const SettingsConfigurationView = () => {
  const { draft, setDraft } = useWorkspaceStore();

  const handleLocalizedInstallsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDraft((prevDraft) => {
      const workspace = prevDraft as Workspace;

      return {
        ...workspace,
        configuration: {
          ...workspace.configuration,
          localizeInstalls: event.target.checked,
        },
      };
    });
  };

  return (
    <Box>
      <Typography variant="h3" color="#3a3a3a">
        Data Settings
      </Typography>
      <Divider sx={{ mt: 1, mb: 2 }} />

      <Box>
        <Stack spacing={2}>
          <Typography variant="h4" color="#3a3a3a">
            Localized Installs
          </Typography>

          <FormControlLabel
            control={
              <Switch
                checked={draft?.configuration?.localizeInstalls ?? true}
                onChange={handleLocalizedInstallsChange}
                disableRipple
              />
            }
            label={
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                  Only return companies where install data is detected in the
                  same country as the company (Recommended)
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.5,
                  }}
                >
                  Disabling this option will return companies if an install is
                  detected anywhere in the company's global footprint, even
                  outside the country of the company. Applicable when filtering
                  by technographic data.
                </Typography>
              </Box>
            }
            sx={{
              alignItems: "flex-start",
              ml: 0,
              "& .MuiFormControlLabel-label": {
                ml: 1,
              },
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
